import { useStores } from "@/hooks/useStores";
import type { DocumentStoreInstance } from "@/stores/types";

/**
 * Hook to access the DocumentStore from the RootStore.
 * Must be used within StoreProvider context.
 */
export function useDocumentStore(): DocumentStoreInstance {
  const rootStore = useStores();
  return rootStore.documentStore;
}
